import axios from 'axios'
import { environment } from '@/data/environment/'

const getUserData = () => {
  return JSON.parse(atob(localStorage.getItem('uid')))
}

const isGeneralAdmin = () => {
  const roles = JSON.parse(localStorage.getItem('role') || '[]')
  return roles.includes('General-Admin') || roles.includes('General')
}

export default {
  namespaced: true,
  state: {
    statusGetPrintDataShop: null,
    statusSetPrintDataShop: null,
    printDataShop: [],
    printDataShopConfigMessage: '',
    listClients: [],
  },
  mutations: {
    setListClients (state, data) {
      state.listClients = data
    },
    setPrintDataShop (state, data) {
      state.printDataShop = data
    },
    setResponseUpdatePrintDataShopConfig (state, data) {
      state.statusSetPrintDataShop = data
    },
    setResponseGetPrintDataShop (state, data) {
      state.statusGetPrintDataShop = data
    },
    setResponsePrintDataShopMsg (state, data) {
      state.printDataShopConfigMessage = data
    },
  },
  actions: {
    getListClients ({ commit }) {
      const endpoint = '/getClients'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      axios
        .create()
        .get(url)
        .then(response => {
          commit('setListClients', response.data)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    getPrintDataShopConfig ({ commit }, data) {
      const userData = getUserData()
      const idCompania = !isGeneralAdmin() ? data.IdCompania : userData.idcompania
      const params = 'IdCompania=' + idCompania

      const endpoint = '/getPrintDataShopConfig?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params

      axios
        .create()
        .get(url)
        .then(response => {
          if (!response.data.respuesta.Error) {
            commit('setPrintDataShop', response.data.respuesta.Datos[0])
            commit('setResponseGetPrintDataShop', false)
            commit('setResponsePrintDataShopMsg', 'Configuración de impresión de datos del establecimiento consultada exitosamente.')
          } else {
            commit('setResponseGetPrintDataShop', true)
            commit('setResponsePrintDataShopMsg', 'Hubo un error obteniendo la configuración de impresión de datos del establecimiento. Inténtelo nuevamente.')
          }
        })
        .catch(function (error) {
          commit('setResponseGetPrintDataShop', true)
          commit('setResponsePrintDataShopMsg', 'No pudo obtener configuración de impresión de datos del establecimiento. Inténtelo nuevamente.')
          console.log(error.message)
        })
    },
    updatePrintDataShopConfig ({ commit }, data) {
      const endpoint = '/updatePrintDataShopConfig'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      const userData = getUserData()
      if (isGeneralAdmin()) {
        data.IdCompania = userData.idcompania
      }

      axios
        .create()
        .put(url, data)
        .then(response => {
          if (!response.data.respuesta.Error) {
            commit('setResponseUpdatePrintDataShopConfig', false)
            commit('setResponsePrintDataShopMsg', response.data.respuesta.Mensaje || 'Configuración de impresión de datos del establecimiento guardada exitosamente.')
          } else {
            commit('setResponseUpdatePrintDataShopConfig', true)
            commit('setResponsePrintDataShopMsg', response.data.respuesta.Mensaje || 'Hubo un error guardando la configuración de impresión de datos del establecimiento. Inténtelo nuevamente.')
          }
        })
        .catch(function (error) {
          commit('setResponseUpdatePrintDataShopConfig', true)
          commit('setResponsePrintDataShopMsg', response.data.respuesta.Mensaje || 'No pudo guardar la configuración de impresión de datos del establecimiento.')
          console.log(error.message)
        })
    },
    setUpdateStatusResponse ({ commit }, data) {
      commit('setResponseUpdatePrintDataShopConfig', data)
    },
    statusGetPrintDataShop ({ commit }, data) {
      commit('setResponseGetPrintDataShop', data)
    },
  },
}
